<template>
  <div :class="{'full-height': isInstantPages}">
    <router-view v-if="!isInstantPages"></router-view>
    <InstantPages v-show="isInstantPages"/>
  </div>
</template>

<script>
import InstantPages from '../../modules/Instant/views/Index.vue'
export default {
  name: "EmptyView",
  components: {
    InstantPages
  },
  computed: {
    isInstantPages () {
      const val = this.$route.name == 'InstantPages';
      if (val) (document.getElementsByClassName('instant')[0] && document.getElementsByClassName('instant')[0].contentWindow.postMessage('refetchInstantPages', '*'))
      return val
    }
  },
}
</script>
